/**
 * Simple event bus for cross-component communication
 * Used to notify admin modules when items are restored from archives
 */

type EventCallback = (data?: any) => void;

class EventBus {
  private events: { [key: string]: EventCallback[] } = {};

  // Subscribe to an event
  on(event: string, callback: EventCallback): void {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  // Unsubscribe from an event
  off(event: string, callback: EventCallback): void {
    if (!this.events[event]) return;
    
    const index = this.events[event].indexOf(callback);
    if (index > -1) {
      this.events[event].splice(index, 1);
    }
  }

  // Emit an event
  emit(event: string, data?: any): void {
    if (!this.events[event]) return;
    
    this.events[event].forEach(callback => {
      try {
        callback(data);
      } catch (error) {
        console.error(`Error in event callback for ${event}:`, error);
      }
    });
  }

  // Remove all listeners for an event
  removeAllListeners(event: string): void {
    delete this.events[event];
  }
}

// Create and export a singleton instance
export const eventBus = new EventBus();

// Event types
export const EVENTS = {
  ITEM_RESTORED: 'item_restored',
  ITEM_ARCHIVED: 'item_archived',
  ITEM_CREATED: 'item_created',
  DATA_REFRESH_NEEDED: 'data_refresh_needed',
  OPEN_FILE_REPORT: 'open_file_report'
} as const;
